










import '@bukalapak/bazaar-mweb/dist/bazaar.css'
import Vue from 'vue'
import DownloadModal from '~/components/organisms/LandingPage/DownloadModal/index.vue'
import LandingFooter from '~/components/organisms/LandingPage/Footer/index.vue'
import LandingHeader from '~/components/organisms/LandingPage/Header/index.vue'
import WhatsappFloatingButton from '~/components/organisms/LandingPage/WhatsappFloatingButton/index.vue'
import TncContent from '~/components/organisms/Terms/TncContent.vue'
import { playStoreLink } from '~/constants/LandingPage'

export default Vue.extend({
  name: 'TermsAndConditions',
  auth: false,
  components: {
    LandingHeader,
    TncContent,
    LandingFooter,
    DownloadModal,
    WhatsappFloatingButton,
  },
  data() {
    return {
      isModalDownloadActive: false,
    }
  },
  head() {
    const url = `https://www.${this.$nuxt.context.$config.cookie.domain}/terms-and-conditions`
    return {
      meta: [{ property: 'og:url', content: url }],
      link: [{ rel: 'canonical', href: url }],
    }
  },
  computed: {
    isMobileTablet(): boolean {
      return this.$viewport.isLessThan('desktop').valueOf()
    },
  },
  methods: {
    handleDownload() {
      if (this.isMobileTablet) {
        window.open(playStoreLink, '_blank')
      } else {
        this.isModalDownloadActive = true
      }
    },
  },
})
